<template>
  <section class="page-container">
    <ArticleLayout
            :no-cta="true"
            :page="index!"
            class="mb-12"
            content-class="tablet:max-w-1/2 mx-auto"
            header-class="text-center section-title text-tertiary"
            img-aspect-ratio="aspect-16/9"
            picture-class="max-w-2xl mx-auto block"
    />
    <div class="tablet:flex gap-x-12">
      <div v-if="youtubeVideoIds" class="tablet:basis-4/9  tablet:shrink-0">
        <MediaYoutube
                v-for="youtubeVideoId in youtubeVideoIds"
                :key="youtubeVideoId"
                :video-id="youtubeVideoId as string"
                class="mb-12 aspect-video rounded-img"
        />
      </div>
      <div>
        <ArticleAccordion
                v-for="page in getAllButIndex(pages)"
                :key="page.path"
                :page="page"
                class="mb-6"
        />
        <div v-if="index?.meta?.cta" class="flex gap-3 flex-wrap">
          <ButtonCta
                  v-for="(cta, _index) in index.meta.cta"
                  :key="_index"
                  :cta="cta"
                  class="btn-brand inline-flex"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="ts" setup>
import type {PageCollectionItemBase} from "@nuxt/content";

const {getIndex, getAllButIndex} = usePage();
const {pages} = defineProps<{
    pages: Array<PageCollectionItemBase>;
}>();
const index: PageCollectionItemBase = getIndex(pages)!;
const youtubeVideoIds = index?.meta?.youtubeVideoId || [];
</script>